import { ScaledRecipe, WeekPlan } from "@/api/types"

const buildMealKey = (mealPlan: WeekPlan['mealPlans'][number]) =>
    `${mealPlan.dayOfWeek}-${mealPlan.mealOfDay}`

const buildRecipeKey = (mealPlan: WeekPlan['mealPlans'][number], scaledRecipe: ScaledRecipe) => {
    const recipeId = scaledRecipe.recipe?.idRecipe
    const fallbackId = scaledRecipe.idScaledRecipe
    return `${mealPlan.dayOfWeek}-${mealPlan.mealOfDay}-${recipeId ?? `scaled-${fallbackId}`}`
}

export const computeReplacedMeals = (oldPlan?: WeekPlan, newPlan?: WeekPlan) => {
    if (!oldPlan || !newPlan) return {}

    const oldMealRecipes = new Map<string, Set<string>>()

    oldPlan.mealPlans.forEach((meal) => {
        const mealKey = buildMealKey(meal)
        const recipeKeys = new Set(meal.scaledRecipes.map((sr) => buildRecipeKey(meal, sr)))
        oldMealRecipes.set(mealKey, recipeKeys)
    })

    const updatedMeals: Record<string, boolean> = {}

    newPlan.mealPlans.forEach((meal) => {
        const mealKey = buildMealKey(meal)
        const newRecipeKeys = meal.scaledRecipes.map((sr) => buildRecipeKey(meal, sr))
        const previousRecipes = oldMealRecipes.get(mealKey)

        if (!previousRecipes) {
            updatedMeals[mealKey] = true
            return
        }

        if (previousRecipes.size !== newRecipeKeys.length) {
            updatedMeals[mealKey] = true
            return
        }

        for (const key of newRecipeKeys) {
            if (!previousRecipes.has(key)) {
                updatedMeals[mealKey] = true
                return
            }
        }
    })

    return updatedMeals
}